<template>
<div
>
    <m-make-payment-app-bar
        :value="bill_from_organization_name"
        :banner_branding="banner_branding"
    />

    <div
        v-if="payment_not_found"
        class="payment_not_found"
      >
        Payment request not found
      </div>

      <div
        v-if="payment_void"
        class="payment_void"
      >
        Payment request has been cancelled
      </div>

      <m-make-payment-invoice-and-amount
        :payment="payment"
      />

      <m-make-payment-thank-you
        :payment="payment"
      />

      <m-make-payment-address
        shipping
        :payment="payment"
        :active="stage == 1"
        v-if="show_shipping_address"
        v-on:continue="onContinue"
        ref="shipping-address"
      />

      <m-make-payment-address
        :payment="payment"
        :active="stage == 2"
        v-if="show_billing_address"
        v-on:continue="onContinue"
        ref="billing-address"
        :allow_same_as_shipping="allow_same_as_shipping"
      />

      <m-make-payment-pay-by-card
        :payment="payment"
        v-on:on-pay="onPay"
        v-if="stage == 3 && payment_mode == 'credit'"
        v-on:swich-to-pay-by-ach="onSwitchToPayByACH"
      />

      <m-make-payment-pay-by-ach
        :payment="payment"
        v-on:on-pay="onPay"
        v-if="stage == 3 && payment_mode == 'ach'"
        v-on:swich-to-pay-by-credit="onSwitchToPayByCredit"
      />



      <div
        style="text-align: center; margin-top: 15px;"
        v-if="show_cancel_button"
      >
      
        <v-btn
            v-on:click="onClickCancel"
        >
            Cancel
        </v-btn>

      </div>

      <div
        style="text-align: center; position: relative; left: 10px; margin-top: 25px"
      >
        <img src="https://files.redchirp.com/static/secure-badge.svg" width="150px" />
        <img src="https://files.redchirp.com/static/payment-protection-badge.svg" width="150px" />
      </div>

  
</div>
</template>

<script>
export default {
    props: {
        payment: {
            type: Object,
            default: function() { return null; }
        },

        banner_branding: {
            type: Object,
            default: function() { return null; }
        },

        payment_not_found: {
            type: Boolean,
            default: function() { return false; }
        },

        stage: {
            type: Number,
            default: function() { return 1; }
        },

        preview: {
          type: Boolean,
          default: function() { return false; }
        },
    },

    data() {
        return {
          payment_mode: 'credit',
        }
    },

    mounted () {
      this.autoSwitchPaymentMode();
    },

    methods: {
      onPay(info) 
      {
        let payment_info_credit_card = null;
        let payment_info_ach = null;

        if ( info.account_type != null )
          payment_info_ach = info;
        else
          payment_info_credit_card = info;

        let billing_address = null;
        let shipping_address = null;

        if ( this.show_shipping_address )
        {
          shipping_address = this.$refs['shipping-address'].createAddress();
          
          if ( shipping_address.error != null )
          {
            this.$rc.snackbar(shipping_address.error,3500);
            return;
          }
        }

        if ( this.show_billing_address )
        {
          billing_address = this.$refs['billing-address'].createAddress();

          if ( billing_address.error != null )
          {
            this.$rc.snackbar(billing_address.error,3500);
            return;
          }

          if ( billing_address.same_as_shipping == true )
            billing_address = shipping_address;
        }

        let post_data = {
          'response_time' : new Date().getTime(),
          'payment_info_credit_card' : payment_info_credit_card,
          'payment_info_ach': payment_info_ach,
          'billing_address' : billing_address,
          'shipping_address' : shipping_address,
          'age_verification_provided_text' : info.age_verification_provided_text,
        };

        if ( this.preview == true )
        {
          this.$rc.alert('Preview payment complete', 'This is a payment preview.<br/><br/>Had this been an actual payment request, the payment information would have been submitted.');
          return;
        }

        this.$rc.showSpinner();
        
        this.$rc.providePayment(
          this.payment.payment_id,
          post_data,

          () => {
            this.$emit('update');
          },

          () => {
            this.$rc.alert('Unable to make payment', 'Your payment could not be made, please try again later.');
          }
        );
      },

      onContinue()
      {
        let new_stage = this.stage + 1;
        if ( new_stage > 3 ) new_stage = 3;
        this.$emit('change-stage',new_stage);

        setTimeout( () => { window.scrollTo(0,document.body.scrollHeight); }, 150 );
      },

      onClickCancel()
      {
           document.location = this.payment.request.url_cancel;
      },

      onSwitchToPayByACH()
      {
        if ( !this.accept_ach ) return;
        this.payment_mode = 'ach';
      },

      onSwitchToPayByCredit()
      {
        if ( !this.accept_ach ) return;
        this.payment_mode = 'credit';
      },

      autoSwitchPaymentMode()
      {
        if ( this.accept_credit == false && this.accept_ach == true )
        {
          this.payment_mode = 'ach';
        }  
        if ( this.accept_credit == true && this.accept_ach == false )
        {
          this.payment_mode = 'credit';
        }  
      },
    },

    computed: {
      bill_from_organization_name() {
        if ( this.payment == null ) return null;
        return this.payment.request.bill_from.bill_from_organization_name;
      },

      payment_void() {
        if ( this.payment == null ) return false;
        return this.payment.state == 'void';
      },

      show_shipping_address() {
        if ( this.payment == null ) return false;
        return this.payment.request.amount_of_address_information == 'billing-and-shipping-address';
      },

      show_billing_address() {
        if ( this.payment == null ) return false;

        let amount = this.payment.request.amount_of_address_information;

        return this.stage >= 2 && (amount == 'billing-and-shipping-address' || amount == 'billing-address');
      },

      allow_same_as_shipping() {
        if ( this.payment == null ) return false;
        let amount = this.payment.request.amount_of_address_information;
        if ( amount != 'billing-and-shipping-address' ) return false;
        return true;
      },

      show_cancel_button() {
        if ( this.payment == null ) return false;
        if ( this.payment.request == null ) return false;
        if ( this.payment.request.url_cancel == null ) return false;

        if ( this.show_shipping_address ) return true;
        if ( this.show_billing_address ) return true;
        if ( this.stage == 3 ) return true;

        return false;
      },

      accept_ach()
      {
        if ( this.payment == null ) return false;
          return this.payment.request.accept_ach;
      },

      accept_credit()
      {
        if ( this.payment == null ) return false;
          return this.payment.request.accept_visa || this.payment.request.accept_mastercard || this.payment.request.accept_amex || this.payment.request.accept_discover;
      },
    },

    watch: {
      payment(newValue, oldValue) 
      {
        this.autoSwitchPaymentMode();
      }
    },
}
</script>

<style lang="scss" scoped>
.payment_not_found
{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}

.payment_void
{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>